/* src/assets/styles/common.css */
.flex {
  display: flex;
}
.flex-row {
  flex-direction: row;
}
.flex-column {
  flex-direction: column;
}
.flex.jc-e {
  justify-content: end;
}
.flex.jc-c {
  justify-content: center;
}
.flex.jc-sb {
  justify-content: space-between;
}
.flex.align-c {
  align-items: center;
}
.flex.align-fe {
  align-items: flex-end;
}
.flex.align-fs {
  align-items: flex-start;
}
.flex.gap-10 {
  gap: 10px;
}
.flex.gap-20 {
  gap: 20px;
}
.flex.gap-50 {
  gap: 50px;
}
.ac-fs {
  align-content: flex-start;
}
.text-align-center {
  text-align: center;
}
.text-align-right {
  text-align: right;
}
.container {
  padding: 1rem;
}
.mg-t-5 {
  margin-top: 5px;
}
.mg-t-10 {
  margin-top: 10px;
}
.mg-r-10 {
  margin-top: 20px;
}
.width100 {
  width: 100%;
}
.width90 {
  width: 90%;
}
.bold {
  font-weight: 800;
}
.col-1 {
  width: calc(100% * 1 / 12);
}
.col-2 {
  width: calc(100% * 2 / 12);
}

/* src/app/modules/portal/components/skeletons.scss */
.loading-skeleton {
  position: relative;
}
.loading-skeleton::after {
  content: "";
  opacity: 0;
  display: inline-block;
  pointer-events: none;
  position: absolute;
  transition: opacity 0.3s;
  left: 0%;
  top: 0%;
  width: 100%;
  height: 100%;
  animation-duration: 2.25s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background:
    linear-gradient(
      to right,
      #bbbbbb 10%,
      #aaaaaa 18%,
      #bbbbbb 33%);
  background-size: 300% 100%;
}
.loading .loading-skeleton * {
  color: rgba(0, 0, 0, 0);
}
.loading .loading-skeleton::after {
  transition: opacity 0s;
  opacity: 1;
}
.loading .loading-skeleton.dark:after {
  background-image:
    linear-gradient(
      to right,
      rgba(53, 50, 50, 0.6) 10%,
      rgba(141, 133, 133, 0.6) 18%,
      rgba(53, 50, 50, 0.6) 33%);
}
.loading .loading-skeleton.light:after {
  background-image:
    linear-gradient(
      to right,
      #eeeeee 10%,
      #dddddd 18%,
      #eeeeee 33%);
}
@keyframes placeHolderShimmer {
  0% {
    background-position: 0% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

/* src/app/modules/portal/components/system-details/system-details.component.scss */
[theme=dark] :host-context .system-details {
  background: rgba(var(--base-0), 0.2);
}
:host {
  box-shadow: 0.125rem 0.125rem 0.25rem rgba(0, 0, 0, 0.15);
}
:host-context .srs-connectivity-small {
  display: none;
}
:host-context sh-icon {
  display: inline-block;
}
:host-context .system-details {
  display: flex;
  flex-direction: column;
  background: #d8d8d8;
  height: 100%;
}
:host-context .system-details sh-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
:host-context .system-details .body {
  max-width: 92%;
  padding: 5px 20px;
}
:host-context .info-section {
  overflow: hidden;
}
:host-context .icon-title sh-icon {
  margin-right: 5px;
}
:host-context .seperator {
  border-bottom: 1px solid rgba(150, 150, 150, 0.6) !important;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
:host-context .collapsable-ic {
  position: relative;
}
:host-context .collapsable-ic sh-icon {
  transition: all calc(var(--transition-time) * 1);
  position: absolute;
  top: 0%;
  transform: translate(0, 50%);
}
:host-context .loading .product-name {
  opacity: 0;
}
:host-context .system-image {
  display: flex;
  max-height: 230px;
  min-height: 200px;
  min-width: 140px;
  position: relative;
}
:host-context .system-image > img {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0;
  transition: opacity calc(var(--transition-time) * 4);
}
:host-context .system-image > img[placeholder] {
  opacity: 1;
}
:host-context .system-image.has-product-picture > img[placeholder] {
  opacity: 0;
}
:host-context .system-image.loading > img {
  opacity: 0;
}
:host-context .system-image.loading > img[placeholder] {
  opacity: 1;
}
:host-context .system-image > img.loaded {
  opacity: 1;
}
:host-context .product-name {
  transition: all calc(var(--transition-time) * 1);
  background-color: rgba(53, 50, 50, 0.6);
  top: 100%;
  cursor: pointer;
  transform: translate(0%, -100%);
  position: absolute;
  z-index: 1;
  padding: 0.5rem;
  width: 100%;
  box-sizing: border-box;
  color: #ffffff;
}
:host-context .product-name sh-text {
  display: -webkit-box;
  transition: -webkit-line-clamp calc(var(--transition-time) * 1);
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow-y: hidden;
  text-overflow: initial;
  white-space: initial;
  color: #ffffff;
}
:host-context .product-name sh-text.product-sno {
  line-height: 22px;
  word-break: keep-all;
}
:host-context .system-info {
  padding: 0rem;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
}
:host-context .srs-connectivity {
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
}
:host-context .basic-info {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
}
:host-context .delivery-dates {
  margin: 0rem;
  min-width: 1rem;
  width: 100%;
  flex: 1 0;
}
:host-context .hide-row {
  display: none;
}
:host-context .info-section {
  min-width: calc(100% - 1rem);
  max-width: calc(100% - 1rem);
  flex: 1 0;
  margin: 0.5rem;
}
:host-context .inactive-text {
  padding-left: 4px;
}
[screen-desktop] :host-context .system-details,
[screen-desktop-large] :host-context .system-details {
  overflow-x: hidden;
}
[screen-desktop] :host-context .srs-connectivity,
[screen-desktop-large] :host-context .srs-connectivity {
  width: 100%;
  flex-direction: column;
}
[screen-desktop] :host-context .collapsable-ic,
[screen-desktop-large] :host-context .collapsable-ic {
  display: none;
}
[screen-desktop] :host-context .system-info,
[screen-desktop-large] :host-context .system-info {
  padding: 0.5rem;
}
[screen-desktop] :host-context .product-name,
[screen-desktop-large] :host-context .product-name {
  top: initial;
  transform: translate(0%, 0%);
  bottom: 0px;
  height: initial;
  max-height: 120px;
}
[screen-desktop] :host-context .product-name sh-text,
[screen-desktop-large] :host-context .product-name sh-text {
  white-space: initial;
}
[screen-desktop] :host-context .product-name sh-text.product-sno,
[screen-desktop-large] :host-context .product-name sh-text.product-sno {
  line-height: 22px;
  word-break: keep-all;
}
[screen-desktop] :host-context .country-city-mobile,
[screen-desktop-large] :host-context .country-city-mobile {
  display: none;
}
[screen-tablet] :host-context .system-details .header .product-name sh-text.product-sno,
[screen-phone] :host-context .system-details .header .product-name sh-text.product-sno {
  font-size: 16px !important;
}
[screen-tablet] :host-context hr.seperator,
[screen-phone] :host-context hr.seperator {
  margin-top: 0rem;
  margin-bottom: 0rem;
}
[screen-tablet] :host-context :host,
[screen-phone] :host-context :host {
  width: 100%;
}
[screen-tablet] :host-context .system-details,
[screen-phone] :host-context .system-details {
  overflow-y: hidden;
  min-height: auto;
  display: flex;
  flex-direction: row;
}
[screen-tablet] :host-context .system-info,
[screen-phone] :host-context .system-info {
  width: 50%;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  flex: 1 0;
  flex-direction: row;
  flex-wrap: wrap;
}
[screen-tablet] :host-context .system-info .info-section,
[screen-phone] :host-context .system-info .info-section {
  flex: 1 0;
}
[screen-tablet] :host-context .system-info .info-section sh-text,
[screen-phone] :host-context .system-info .info-section sh-text {
  overflow-x: hidden;
  text-overflow: ellipsis;
}
[screen-tablet] :host-context .system-info .software-version,
[screen-phone] :host-context .system-info .software-version {
  padding-right: 5rem;
  box-sizing: border-box;
}
[screen-tablet] :host-context .delivery-dates-separator,
[screen-phone] :host-context .delivery-dates-separator {
  height: 0px;
  opacity: 0;
  transition: height var(--transition-time), opacity calc(var(--transition-time) * 2);
}
[screen-tablet] :host-context .delivery-dates,
[screen-phone] :host-context .delivery-dates {
  display: flex;
  opacity: 0;
  height: 0px;
  transition: height var(--transition-time), opacity calc(var(--transition-time) * 2);
}
[screen-tablet] :host-context .location,
[screen-phone] :host-context .location {
  display: none;
}
[screen-tablet] :host-context .side-info-pane .body,
[screen-phone] :host-context .side-info-pane .body {
  max-width: initial;
  padding: 15px 5px 0px;
  max-height: 100%;
}
[screen-tablet] :host-context .side-info-pane,
[screen-phone] :host-context .side-info-pane {
  padding-bottom: 12px;
}
[screen-tablet] :host-context hr.seperator,
[screen-phone] :host-context hr.seperator {
  width: 100%;
}
[screen-tablet] :host-context .side-info-pane .header .product-name sh-text.product-sno,
[screen-phone] :host-context .side-info-pane .header .product-name sh-text.product-sno {
  font-size: 12px !important;
  line-height: 20px;
}
[screen-tablet] :host-context .side-info-pane .header .product-name sh-text.product-desc,
[screen-phone] :host-context .side-info-pane .header .product-name sh-text.product-desc {
  font-size: 10px !important;
  white-space: normal;
}
[screen-tablet] :host-context .collapsable-ic,
[screen-phone] :host-context .collapsable-ic {
  width: 40px;
}
[screen-tablet] :host-context .info-section.mobile-only,
[screen-phone] :host-context .info-section.mobile-only {
  display: none;
}
[screen-tablet] :host-context .srs-connectivity,
[screen-phone] :host-context .srs-connectivity {
  flex-wrap: nowrap;
  width: 100%;
  max-height: 60px;
}
[screen-tablet] :host-context .srs-connectivity .icon-title,
[screen-phone] :host-context .srs-connectivity .icon-title {
  max-height: calc(60px - 1rem);
  height: calc(60px - 1rem);
}
[screen-tablet] :host-context .details-expanded,
[screen-phone] :host-context .details-expanded {
  position: relative;
}
[screen-tablet] :host-context .details-expanded .product-name,
[screen-phone] :host-context .details-expanded .product-name {
  transform: translate(0%, 0%);
  height: initial;
}
[screen-tablet] :host-context .details-expanded .product-name sh-text.product-sno,
[screen-tablet] :host-context .details-expanded .product-name sh-text,
[screen-phone] :host-context .details-expanded .product-name sh-text.product-sno,
[screen-phone] :host-context .details-expanded .product-name sh-text {
  -webkit-line-clamp: initial;
  word-break: initial;
  white-space: initial;
}
[screen-tablet] :host-context .details-expanded .basic-info,
[screen-phone] :host-context .details-expanded .basic-info {
  min-height: 60px;
  height: initial;
  max-height: initial;
}
[screen-tablet] :host-context .details-expanded .collapsable-ic sh-icon,
[screen-phone] :host-context .details-expanded .collapsable-ic sh-icon {
  bottom: 1rem;
}
[screen-tablet] :host-context .details-expanded .srs-connectivity,
[screen-phone] :host-context .details-expanded .srs-connectivity {
  display: flex;
  flex-wrap: wrap;
  max-height: initial;
  width: 100%;
}
[screen-tablet] :host-context .details-expanded .delivery-dates-separator,
[screen-phone] :host-context .details-expanded .delivery-dates-separator {
  height: 1px;
  opacity: 1;
}
[screen-tablet] :host-context .details-expanded .basic-info,
[screen-phone] :host-context .details-expanded .basic-info {
  max-height: initial;
  flex-wrap: wrap;
}
[screen-tablet] :host-context .details-expanded .system-info .software-version,
[screen-phone] :host-context .details-expanded .system-info .software-version {
  padding-right: initial;
}
[screen-tablet] :host-context .details-expanded .info-section,
[screen-phone] :host-context .details-expanded .info-section {
  flex: 1 0;
}
[screen-tablet] :host-context .details-expanded .info-section sh-text,
[screen-phone] :host-context .details-expanded .info-section sh-text {
  white-space: initial;
}
[screen-tablet] :host-context .system-image {
  height: 200px;
  max-height: 120px;
  min-height: 120px;
  width: 16.6666666667%;
}
[screen-tablet] :host-context .hide-tablet {
  display: none;
}
[screen-tablet] :host-context .info-section {
  min-width: calc(33% - 1rem);
  max-width: calc(33% - 1rem);
}
[screen-tablet] :host-context .details-expanded .product-name {
  height: 500px;
}
[screen-tablet] :host-context .details-expanded .delivery-dates {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  height: fit-content;
  opacity: 1;
}
[screen-tablet] :host-context .details-expanded .delivery-dates .info-section:nth-child(1) {
  order: 2;
}
[screen-tablet] :host-context .details-expanded .delivery-dates .info-section:nth-child(2) {
  order: 1;
}
[screen-tablet] :host-context .details-expanded .delivery-dates .info-section:nth-child(3) {
  order: 3;
}
[screen-phone] :host-context .srs-connectivity-small {
  display: flex;
  flex-direction: row;
  position: absolute;
  right: 1rem;
  bottom: 0.5rem;
  align-items: center;
}
[screen-phone] :host-context .system-image {
  height: 200px;
  max-height: 140px;
  min-height: 140px;
  width: 16.6666666667%;
}
[screen-phone] :host-context .seperator {
  display: none;
}
[screen-phone] :host-context .basic-info {
  gap: 0.5rem;
}
[screen-phone] :host-context .system-info {
  position: relative;
  padding: 0.5rem;
  padding-left: 1rem;
  width: calc(50% - 1.5rem);
}
[screen-phone] :host-context .info-section {
  margin: 0rem;
}
[screen-phone] :host-context .hide-phone {
  display: none;
}
[screen-phone] :host-context .srs-connectivity {
  display: none;
  gap: 0.5rem;
}
[screen-phone] :host-context .delivery-dates {
  display: flex;
  flex-direction: column;
}
[screen-phone] :host-context .details-expanded .system-info {
  gap: 0.5rem;
}
[screen-phone] :host-context .details-expanded .product-name {
  transform: translate(0%, 0%);
}
[screen-phone] :host-context .details-expanded .delivery-dates {
  gap: 0.5rem;
  flex-wrap: wrap;
  width: 100%;
  height: fit-content;
  opacity: 1;
}
/*# sourceMappingURL=system-details.component.css.map */
